import React from 'react';
import './actual.css';
import mainImg from "../acepts/uzb_img1.jpg";

function Actual(props) {
    return (
        <div>
               <div className="card mb-1" data-aos="fade-up">
              <div className="actual_left_shadow"></div>
              <img src={mainImg} className="card-img-top" alt="..." />
              <div className="card-body actual_cart_text">
                <h5 className="card-title">Card title</h5>
                <p className="card-text">
                  This is a wider card with supporting text below as a natural
                  lead-in to additional content. This content is a little bit
                  longer.
                  <small className="text-muted ms-4">Last updated 3 mins ago</small>
                </p>
              </div>
            </div>
            <div className="card mt-1" data-aos="fade-up">
            <div className="actual_left_shadow"></div>
              <img src={mainImg} className="card-img-top" alt="..." />
              <div className="card-body actual_cart_text">
                <h5 className="card-title">Card title</h5>
                <p className="card-text">
                  This is a wider card with supporting text below as a natural
                  lead-in to additional content. This content is a little bit
                  longer.
                </p>
              </div>
            </div>
            <div className="card mt-1" data-aos="fade-up">
            <div className="actual_left_shadow"></div>
              <img src={mainImg} className="card-img-top" alt="..." />
              <div className="card-body actual_cart_text">
                <h5 className="card-title">Card title</h5>
                <p className="card-text">
                  This is a wider card with supporting text below as a natural
                  lead-in to additional content. This content is a little bit
                  longer.
                </p>
              </div>
            </div>
          </div>
        
    );
}

export default Actual;